import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { GET_ALL_Video, GET_Video_Layer, GET_Continue_QB, GET_Free_QB } from "../../gql/queries";
import { Link, NavLink, useNavigate, useParams ,useLocation} from "react-router-dom";
import { useQuery } from "@apollo/client";
import { getPercentage, getqbPercentage } from "../../utils";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import { decrypt } from "../../utils/crypto";
import NoDataFound from "../common/NoDataFound/NoDataFound";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import ConnectionError from "../common/NoDataFound/ConnectionError";
import { trackEvent } from "../../../src/utils/moengageUserSetup";
export default function QbTopics() {
    const completePathUrl = useLocation()
    let { id } = useParams()
    const navigate = useNavigate();
    const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    const packageStatus = JSON.parse(decrypt(localStorage.getItem('packageStatus')))
    const query1 = useQuery(GET_Video_Layer, {
        variables: {
            "_id": id,
            "language": '',
            "contentType": "qb"
        },
    });
trackEvent("ViewedWebPage", {
    url: window.location.href,
    timestamp: Date.now(),
  });
    const query2 = useQuery(GET_ALL_Video, {
        variables: {
            "courseName": course.preparingFor,
            "version": 400,
            "status": true,
            "contentType": "qb",
            "isRoot": true
        },
    });

    const query3 = useQuery(GET_Continue_QB, {
        variables: {
            "courseName": course.preparingFor
        },
    });
    const query4 = useQuery(GET_Free_QB, {
        variables: {
            "courseName": [course.preparingFor],
            "page": 1,
            "limit": 3
        },
    });
    if (query1.loading || query2.loading || query3.loading || query4.loading) return (<><Loader /></>)
    if (query1.error || query2.error || query3.error || query4.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED') || query2.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED') || query3.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED') || query4.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            authorizationCheck(navigate)
            }
            else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')|| query2.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR') || query3.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR') || query4.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
                return (<>
                    <div className="main_wrapper">
                        <div className="col-lg-12">
                            <SomethingWentWrong pathName={completePathUrl.pathname} />
                        </div>
                    </div>
                </>)
            }
             else {
              return (<>
	  <div className="main_wrapper">
                <div className="col-lg-12">
                    <ConnectionError pathName={completePathUrl.pathname}/>
                </div>
                </div>
		</>)

            }
        console.log(query1.error)
    }
    let subjectlist
    query2.data && query2.data.layers.slice().sort((a, b) => (a.position > b.position ? 1 : -1)).map(obj => {
        if (obj.layerType === 'subject_list') {
            subjectlist = obj.subLayers
            return
        }
    })
    let key
    query1.data && query1.data.layer.subLayers.map((o, i) => {
        if (o.position === 1) {
            key = i
            return
        }
    })

    if (query1.data.layer.subLayers.length === 0) {
        return (<>
            <div className="main_wrapper">
                <div className="col-lg-12">
                    <NoDataFound />
                </div>
            </div>
        </>)
    }

    let sortedSubLayers
    if (query1.data && query1.data.layer && query1.data.layer.subLayers) {
        // Create a copy of the subLayers array before sorting
         sortedSubLayers = [...query1.data.layer.subLayers];
      
        sortedSubLayers.sort((a, b) => a.position - b.position);
      
        // Now, sortedSubLayers contains the sorted array, and query1.data.layer.subLayers remains unchanged.
      }
    // console.log(key, "kkkkkkkkkkkkkkkkkkk")
    return (
        <>
            {
                sortedSubLayers && sortedSubLayers !== null && query1.data.layer.subContents === null && ( sortedSubLayers[0] &&  sortedSubLayers[0].layerType === 'topic') && query1.data && sortedSubLayers !== null && query1.data.layer.subContents === null && (query1.data && sortedSubLayers[0] && query1.data && sortedSubLayers[0].layerType !== 'subject') &&  sortedSubLayers !== null && query1.data.layer.subContents === null && (sortedSubLayers[0] && sortedSubLayers[0].layerType !== null) &&
                <div className="main_wrapper">
                    <div className="breadcrumbs">
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><a>Home</a></li>
                            <li className="breadcrumb-item">QBank</li>
                            <li className="breadcrumb-item active">{query1.data ? query1.data.layer.title : ""}</li>
                        </ul>
                    </div>
                    <section className="videoLayer_wrapper qbanks_wrapper section_side_padding">
                        <div className="row">
                            <div className="col-lg-8 col-md-7 col-sm-12">
                                <div className="topics_wrapper_main">
                                    <div className="subjects_wrapper topic_header">
                                        <div className="topic_header_content d-flex align-items-center">
                                            <div className="topic_image_ttl d-flex align-items-center">
                                                <Link to='/qblayer'>
                                                    <figure className="back_arrow">
                                                        <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                    </figure>
                                                </Link>
                                                <figure className="subject_inner_img">
                                                    <img src={query1.data ? query1.data.layer.icon : ''} alt="Subject Image" className="img-fluid" />
                                                </figure>
                                                <div className="subject_ttl_detail">
                                                    <h5>{query1.data ? query1.data.layer.title : ''}</h5>
                                                    <p><span>QBank</span></p>
                                                </div>
                                            </div>
                                            {/* <div className="search_icon">
                                                <img src={Icons.SearchIcon} alt="" className="img-fluid" />
                                            </div> */}
                                        </div>


                                        <div className="progress_bar">
                                            <div className="progress_details d-flex align-items-center">
                                                <div className="progress">
                                                    <div className="progress-bar" style={{ width: `${getPercentage(query1.data ? query1.data.layer : 0)}%` }}></div>
                                                </div>
                                                <div className="completed_text">
                                                    <span>{`${getPercentage(query1.data ? query1.data.layer : 0)}%`}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="subjects_wrapper subject_topics_wrapper">
                                        <div className="subjects_header">
                                            <h6>Topics <span>({query1.data ? sortedSubLayers.length : 0})</span></h6>
                                        </div>
                                        <div className="all_subjects_name_wrapper">
                                            <ul type="none" className="subjects_child d-flex flex-wrap">
                                                {
                                                    query1.data && query1.data.layer != null && sortedSubLayers.sort((a, b) => (a.position > b.position ? 1 : -1)).map((d, i) => (
                                                        <li>
                                                            <Link to={`/qblayer/qblayercontent/${d._id}`} state={id}>
                                                                <div className="subject_main_list d-flex align-itmes-center">
                                                                    <div className="subject_img_wrap d-flex align-items-center">
                                                                        <figure className="subject_img">
                                                                            <img src={d.icon} alt="" className="img-fluid" />
                                                                        </figure>
                                                                        <div className="subject_details">
                                                                            <h6>{d.title}</h6>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        getPercentage(d) !== 0 &&
                                                                        <div className="progressbar_wraper d-flex align-items-center">
                                                                            <div className="progress_details">
                                                                                <span>{`${getPercentage(d)}%`}</span>
                                                                                <div className="progress">
                                                                                    <div className="progress-bar" style={{ width: `${getPercentage(d)}%` }}></div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="right_arrow">
                                                                                <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    ))
                                                }
                                                {/* <li>
                                            <div className="subject_main_list d-flex align-itmes-center">
                                                <div className="subject_img_wrap d-flex align-items-center">
                                                    <figure className="subject_img">
                                                        <img src={Icons.Brain} alt="" className="img-fluid"/>
                                                    </figure>
                                                    <div className="subject_details">
                                                        <h6>Neuroanatomy</h6>
                                                    </div>
                                                </div>
                                                <div className="progressbar_wraper d-flex align-items-center">
                                                    <div className="progress_details">
                                                        <span>40%</span>
                                                        <div className="progress">
                                                            <div className="progress-bar" style={{width:"30%"}}></div>
                                                        </div>
                                                    </div>
                                                    <div className="right_arrow">
                                                        <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subject_main_list d-flex align-itmes-center">
                                                <div className="subject_img_wrap d-flex align-items-center">
                                                    <figure className="subject_img">
                                                        <img src={Icons.Embryology} alt="" className="img-fluid"/>
                                                    </figure>
                                                    <div className="subject_details">
                                                        <h6>Systemic Embryology</h6>
                                                    </div>
                                                </div>
                                                <div className="progressbar_wraper d-flex align-items-center">
                                                    <div className="progress_details">
                                                        <span>40%</span>
                                                        <div className="progress">
                                                            <div className="progress-bar" style={{width:"30%"}}></div>
                                                        </div>
                                                    </div>
                                                    <div className="right_arrow">
                                                        <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subject_main_list d-flex align-itmes-center">
                                                <div className="subject_img_wrap d-flex align-items-center">
                                                    <figure className="subject_img">
                                                        <img src={Icons.Thorax} alt="" className="img-fluid"/>
                                                    </figure>
                                                    <div className="subject_details">
                                                        <h6>Thorax</h6>
                                                    </div>
                                                </div>
                                                <div className="progressbar_wraper d-flex align-items-center">
                                                    <div className="progress_details">
                                                        <span>40%</span>
                                                        <div className="progress">
                                                            <div className="progress-bar" style={{width:"30%"}}></div>
                                                        </div>
                                                    </div>
                                                    <div className="right_arrow">
                                                        <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subject_main_list d-flex align-itmes-center">
                                                <div className="subject_img_wrap d-flex align-items-center">
                                                    <figure className="subject_img">
                                                        <img src={Icons.Abdomen} alt="" className="img-fluid"/>
                                                    </figure>
                                                    <div className="subject_details">
                                                        <h6>Abdomen, Pevis & Perineum</h6>
                                                    </div>
                                                </div>
                                                <div className="progressbar_wraper d-flex align-items-center">
                                                    <div className="progress_details">
                                                        <span>40%</span>
                                                        <div className="progress">
                                                            <div className="progress-bar" style={{width:"30%"}}></div>
                                                        </div>
                                                    </div>
                                                    <div className="right_arrow">
                                                        <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </li> */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-5 col-sm-12">
                                {/* <div className="videos_wrapper">
                                    <div className="recommended_video_wrapper Free_videos_wrapper">
                                        <div className="subjects_header">
                                            <h6>Continue QBank</h6>
                                            <div className="view_all_text d-flex align-items-center">
                                                <div className="main_paragraph">
                                                    <p>Resume your question bank</p>
                                                </div>
                                                <div className="view_text">
                                                    <p><a href="/">View All</a></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="recommend_video_details">
                                            <ul type="none" className="recommend_list">
                                                {
                                                    query3.data && query3.data.continueLearningQb.map((d, i) => (
                                                        <li>
                                                            <div className="recommend_list_main d-flex align-items-center">
                                                                <figure className="user_img pos_rel">
                                                                    <img src={Images.Qbmark} alt="" className="img-fluid" />
                                                                    <figcaption className="free_tag">
                                                                        {
                                                                            d.questionbank.purchaseStatus !== 0 &&
                                                                            <span>
                                                                                <img src={Icons.Lock} alt="Lock" className='img-fluid' /> Pro
                                                                            </span>
                                                                        }
                                                                        {
                                                                            d.questionbank.purchaseStatus === 0 &&
                                                                            <span>Free</span>
                                                                        }
                                                                    </figcaption>
                                                                    <span className="text_qb">QB</span>
                                                                </figure>
                                                                <div className="recommend_list_content">
                                                                    <div className="continue_qbanks_wrapper d-flex align-items-baseline">
                                                                        <div className="continue_ttl">
                                                                            <h6>{d.questionbank.title}</h6>
                                                                        </div>
                                                                        <div className="qbanks_rating">
                                                                            <span>
                                                                                <img src={Icons.Star} alt="Star" className="img-fluid" /> {d.questionbank.rating}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="progress_details d-flex align-items-center">
                                                                        <div className="timer_progress d-flex align-items-center">
                                                                            <div className="progress">
                                                                                <div className="progress-bar" style={{ width: `${getqbPercentage(d.questionbank)}%` }}></div>
                                                                            </div>
                                                                            <div className="progress_text">
                                                                                <p><span>{d.questionbank.progress ? d.questionbank.progress.questions.length : 0}/</span>{d.questionbank.questionIds ? d.questionbank.questionIds.length : 0} Questions</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="rightArrow_icn">
                                                                            <img src={Icons.QbRightArrow} alt="Play" className="img-fluid" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div> */}

                                <div className="subjects_wrapper Subject_selection_right_side">
                                    <div className="subjects_header">
                                        <h6>Move to other Subject</h6>
                                    </div>
                                    <div className="all_subjects_name_wrapper">
                                        <ul type="none" className="subjects_child d-flex flex-wrap">
                                            {
                                                subjectlist && subjectlist.slice().sort((a, b) => (a.position > b.position ? 1 : -1)).map((d, i) => (
                                                    <li>
                                                        <NavLink to={`/qblayer/${d._id}`}>
                                                            <div className="subject_main_list d-flex align-itmes-center">
                                                                <div className="subject_img_wrap d-flex align-items-center">
                                                                    <figure className="subject_img">
                                                                        <img src={d.icon} alt="" className="img-fluid" />
                                                                    </figure>
                                                                    <div className="subject_details">
                                                                        <h6>{d.title}</h6>
                                                                        <p>{d.author ? d.author : ''}</p>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    getPercentage(d) !== 0 &&
                                                                    <div className="progressbar_wraper d-flex align-items-center">
                                                                        <div className="progress_details">
                                                                            <span>{`${getPercentage(d)}%`}</span>
                                                                            <div className="progress">
                                                                                <div className="progress-bar" style={{ width: `${getPercentage(d)}%` }}></div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="right_arrow">
                                                                            <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </NavLink>
                                                    </li>
                                                ))
                                            }
                                            {/* <li>
                                        <div className="subject_main_list d-flex align-itmes-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Micro} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>Microbiology</h6>
                                                    <p>Dr.Ashwani Kumar</p>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper d-flex align-items-center">
                                                <div className="progress_details">
                                                    <span>40%</span>
                                                    <div className="progress">
                                                        <div className="progress-bar" style={{ width: "30%" }}></div>
                                                    </div>
                                                </div>
                                                <div className="right_arrow">
                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                </div>
                                            </div>
                                        </div>
                                    </li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            }
            {
                sortedSubLayers && sortedSubLayers !== null && query1.data.layer.subContents === null && ( sortedSubLayers[0] &&  sortedSubLayers[0].layerType === null) &&
                <div className="main_wrapper">
                     <div className="breadcrumbs">
                    <ul className="breadcrumb">
                    </ul>
					</div>
                    <section className="videoLayer_wrapper section_side_padding">
                        <div className="row">
                            <div className="col-lg-8 col-md-7 col-sm-12">
                                <div className="topics_wrapper_main">
                                    <div className="subjects_wrapper topic_header">
                                        <div className="topic_header_content d-flex align-items-center">
                                            <div className="topic_image_ttl d-flex align-items-center">
                                                <Link to={`${'/qblayer'}`}>
                                                    <figure className="back_arrow">
                                                        <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                    </figure>
                                                </Link>
                                                <figure className="subject_inner_img">
                                                    <img src={query1.data.layer ? query1.data.layer.icon : Icons.Head} alt="Subject Image" className="img-fluid" />
                                                </figure>
                                                <div className="subject_ttl_detail">
                                                    <h5>{query1.data.layer && query1.data.layer.title}</h5>
                                                    <p>Other Resources</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        query1.data.layer !== undefined &&
                                        <div className="subjects_wrapper">
                                            <div className="subjects_header">
                                                <h6>All Resources <span>({query1.data.layer ? query1.data.layer.subLayers.length : 0})</span></h6>
                                            </div>
                                            <div className="all_subjects_name_wrapper">
                                                <ul type="none" className="subjects_child d-flex flex-wrap">
                                                    {sortedSubLayers && sortedSubLayers.slice().sort((a, b) => (a.position > b.position ? 1 : -1)).map((d, i) => (
                                                        <li>
                                                            <Link to={`/qblayer/QbOtherResource/${d._id}`}>
                                                                <div className="subject_main_list d-flex align-itmes-center">
                                                                    <div className="subject_img_wrap d-flex align-items-center">
                                                                        <figure className="subject_img">
                                                                            <img src={d.icon} alt="" className="img-fluid" />
                                                                        </figure>
                                                                        <div className="subject_details">
                                                                            <h6>{d.title}</h6>
                                                                            <p>{d.author ? d.author.name : ''}</p>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        getPercentage(d) !== 0 &&
                                                                        <div className="progressbar_wraper d-flex align-items-center">
                                                                            <div className="progress_details">
                                                                                <span>{`${getPercentage(d)}%`}</span>
                                                                                <div className="progress">
                                                                                    <div className="progress-bar" style={{ width: `${getPercentage(d)}%` }}></div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="right_arrow">
                                                                                <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            }
            {
                sortedSubLayers && sortedSubLayers !== null && query1.data.layer.subContents === null && (sortedSubLayers[0] && sortedSubLayers[0].layerType !== 'subject') && ( sortedSubLayers[0] &&  sortedSubLayers[0].layerType !== 'topic') && sortedSubLayers !== null && query1.data.layer.subContents === null && (sortedSubLayers[0] && sortedSubLayers[0].layerType !== null) &&
                <div className="main_wrapper">
                     <div className="breadcrumbs">
                    <ul className="breadcrumb">
                    </ul>
					</div>
                    <section className="videoLayer_wrapper section_side_padding">
                        <div className="row">
                            <div className="col-lg-8 col-md-7 col-sm-12">
                                <div className="topics_wrapper_main">
                                    <div className="subjects_wrapper topic_header">
                                        <div className="topic_header_content d-flex align-items-center">
                                            <div className="topic_image_ttl d-flex align-items-center">
                                                <Link to={`${'/qblayer'}`}>
                                                    <figure className="back_arrow">
                                                        <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                    </figure>
                                                </Link>
                                                <figure className="subject_inner_img">
                                                    <img src={query1.data.layer ? query1.data.layer.icon : Icons.Head} alt="Subject Image" className="img-fluid" />
                                                </figure>
                                                <div className="subject_ttl_detail">
                                                    <h5>{query1.data.layer && query1.data.layer.title}</h5>
                                                    <p>Other Resources</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        query1.data.layer !== undefined &&
                                        <div className="subjects_wrapper">
                                            <div className="subjects_header">
                                                <h6>All Resources <span>({query1.data.layer ? query1.data.layer.subLayers.length : 0})</span></h6>
                                            </div>
                                            <div className="all_subjects_name_wrapper">
                                                <ul type="none" className="subjects_child d-flex flex-wrap">
                                                    {sortedSubLayers && sortedSubLayers.slice().sort((a, b) => (a.position > b.position ? 1 : -1)).map((d, i) => (
                                                        <li>
                                                            <Link to={`/qblayer/QbOtherResource/${d._id}`}>
                                                                <div className="subject_main_list d-flex align-itmes-center">
                                                                    <div className="subject_img_wrap d-flex align-items-center">
                                                                        <figure className="subject_img">
                                                                            <img src={d.icon} alt="" className="img-fluid" />
                                                                        </figure>
                                                                        <div className="subject_details">
                                                                            <h6>{d.title}</h6>
                                                                            <p>{d.author ? d.author.name : ''}</p>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        getPercentage(d) !== 0 &&
                                                                        <div className="progressbar_wraper d-flex align-items-center">
                                                                            <div className="progress_details">
                                                                                <span>{`${getPercentage(d)}%`}</span>
                                                                                <div className="progress">
                                                                                    <div className="progress-bar" style={{ width: `${getPercentage(d)}%` }}></div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="right_arrow">
                                                                                <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            }
            {
                sortedSubLayers && sortedSubLayers !== null && query1.data.layer.subContents === null && (sortedSubLayers[0] && sortedSubLayers[0].layerType === 'subject') &&
                <div className="main_wrapper">
                     <div className="breadcrumbs">
                    <ul className="breadcrumb">
                    </ul>
					</div>
                    <section className="videoLayer_wrapper section_side_padding">
                        <div className="row">
                            <div className="col-lg-8 col-md-7 col-sm-12">
                                <div className="topics_wrapper_main">
                                    <div className="subjects_wrapper topic_header">
                                        <div className="topic_header_content d-flex align-items-center">
                                            <div className="topic_image_ttl d-flex align-items-center">
                                                <Link to={`${'/qblayer'}`}>
                                                    <figure className="back_arrow">
                                                        <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                    </figure>
                                                </Link>
                                                <figure className="subject_inner_img">
                                                    <img src={query1.data.layer ? query1.data.layer.icon : Icons.Head} alt="Subject Image" className="img-fluid" />
                                                </figure>
                                                <div className="subject_ttl_detail">
                                                    <h5>{query1.data.layer && query1.data.layer.title}</h5>
                                                    <p>Other Resources</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        query1.data.layer !== undefined &&
                                        <div className="subjects_wrapper">
                                            <div className="subjects_header">
                                                <h6>All Resources <span>({query1.data.layer ? query1.data.layer.subLayers.length : 0})</span></h6>
                                            </div>
                                            <div className="all_subjects_name_wrapper">
                                                <ul type="none" className="subjects_child d-flex flex-wrap">
                                                    {sortedSubLayers&& sortedSubLayers.slice().sort((a, b) => (a.position > b.position ? 1 : -1)).map((d, i) => (
                                                        <li>
                                                            <Link to={`/qblayer/QbOtherResource/${d._id}`}>
                                                                <div className="subject_main_list d-flex align-itmes-center">
                                                                    <div className="subject_img_wrap d-flex align-items-center">
                                                                        <figure className="subject_img">
                                                                            <img src={d.icon} alt="" className="img-fluid" />
                                                                        </figure>
                                                                        <div className="subject_details">
                                                                            <h6>{d.title}</h6>
                                                                            <p>{d.author ? d.author.name : ''}</p>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        getPercentage(d) !== 0 &&
                                                                        <div className="progressbar_wraper d-flex align-items-center">
                                                                            <div className="progress_details">
                                                                                <span>{`${getPercentage(d)}%`}</span>
                                                                                <div className="progress">
                                                                                    <div className="progress-bar" style={{ width: `${getPercentage(d)}%` }}></div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="right_arrow">
                                                                                <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            }
        </>
    )
}